var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c("label", [_vm._v("Yleisömäärä")]),
      _vm._v(" "),
      _c(
        "multiselect",
        {
          attrs: {
            options: _vm.crowdOptions,
            searchable: true,
            "track-by": "id",
            label: "name",
            "options-limit": 10,
            "allow-empty": false,
            placeholder: "Valitse",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "show-no-results": false,
            "hide-selected": false,
            value: _vm.selectedCrowd,
          },
          on: { select: _vm.onSelect },
        },
        [_c("span", { attrs: { slot: "noResult" }, slot: "noResult" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }